module.exports = __webpack_public_path__ + "img/Hunter-troll-m-70.39212e44.gif";